var axios = { exports: {} };
export {
  axios as __module
};
